<template>
  <div ref="container" class="upload" :class="{ disabled: !enabled, dropping: isOverDropZone, compact: compact }">
    <UploadFileIntro :accept="acceptStr" :max-size="maxSize" @browse="input.click()" :compact="compact" />
  </div>
  <input
    ref="input"
    type="file"
    class="upload__input"
    :accept="acceptStr"
    @input="onFilesSelected($event.target.files)"
    multiple
  />
</template>

<!-- This component should be moved to components folder -->
<script setup>
import { ref } from 'vue'
import { useDropZone } from '@vueuse/core'
import UploadFileIntro from '@/components/Form/Upload/UploadFileIntro.vue'
import { convertToBytes } from '@/utils/numberUtils.js'

const props = defineProps({
  enabled: {
    type: Boolean,
    default: true,
  },
  max: {
    type: Number,
    default: 1,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  maxSize: {
    type: String,
    default: '10 MB',
  },
  accept: {
    type: Array,
    default: () => ['.jpg', '.jpeg', '.png'],
  },
})

const emit = defineEmits(['files'])

const input = ref(null)
const container = ref(null)
const acceptStr = props.accept.join(', ')
const maxSizeBytes = convertToBytes(props.maxSize)

const { isOverDropZone } = useDropZone(container, onFilesSelected)

function onFilesSelected(fileList) {
  const rejected = []
  const files = [...fileList].filter(f => {
    const pass = f.size <= maxSizeBytes && props.accept.find(ext => f.name.toLowerCase().endsWith(ext))
    if (!pass) rejected.push(f)
    return pass
  })

  if (rejected.length > 0) {
    const rejectedFiles = rejected.map(f => `"${f.name}"`).join(', ')
    alert(`The files: ${rejectedFiles} are not allowed.`)
    return
  }

  if (files.length > props.max) {
    alert(`You can't add more than ${props.max} images.`)
    return
  }

  emit('files', files.slice(0, props.max))
  input.value.value = ''
}
</script>

<style lang="scss" scoped>
.upload {
  border: 1px dashed $gray-lighter;
  border-radius: $rounded;
  display: grid;
  gap: $spacing-3;
  padding: $spacing-6;

  &.compact {
    padding: $spacing-3;
    gap: 0;
  }

  &.disabled {
    background-color: $gray-light;
    pointer-events: none;

    &:deep(*) {
      color: $gray;
    }
  }

  &.dropping {
    border: 1px solid $brand-tertiary;
  }
}

.upload__input {
  display: none;
}
</style>
